import { render, staticRenderFns } from "./StablefordScoringDots.vue?vue&type=template&id=31b0c44f&scoped=true&"
import script from "./StablefordScoringDots.vue?vue&type=script&lang=js&"
export * from "./StablefordScoringDots.vue?vue&type=script&lang=js&"
import style0 from "./StablefordScoringDots.vue?vue&type=style&index=0&id=31b0c44f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0c44f",
  null
  
)

export default component.exports